<template>
  <div>
    <!-- loading.. -->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import { store } from "../store.js";
// import CmdK from './CmdK'
// Vue.component('cmd-k', CmdK)

export default {
  created() {},
  mounted() {
    console.log("this.$route.query", this.$route.query);
    this.checkLogin();
    var self = this;
    console.log("create method:");
    if (!this.$route.query.id) {
      //redirec to login_app2
      window.location.href = this.getPath("/login_app");
      console.log("inside if block");
      return;
    }
    //self.storeState.sessionId = this.$route.query.rowId
    console.log(this.$route.query);
    var rid = this.$route.query.id;
    var sid = null;
    let d = { validationId: "5V0HA9E5u8", rowId: rid };
    const path = store.getPath("/get_session_id");
    axios.post(path, d).then((response) => {
      sid = response.data.data.sessionId;
      self.storeState.sessionId = sid;
      localStorage.setItem("sessionId", sid);
      self.$router.push({ path: "/" });
      self.$parent.getUserData();
    });

    //var sid= this.getSession(rid);
    //console.log("in mount", this.responseData)
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      hideIframe: true,
      db: false,
      cmdkActive: false,
      searchTerm: "",
      searchIn: this.$parent.search,
      searchResults: this.$parent.search,
      consumedOn: new Date().toISOString().substr(0, 10),
      consumedOnCal: false,
      addingFood: false,
      removingFood: false,
      expanded: [],
      checked: [],
      amount: "",
      userEntries: [],
      userEntriesHeader: [],
      loadingUserData: false,
      loading: true,
      selectedFood: false,
      unit: "g",
      headers: [],
      foodFacts: [],
      amountRules: [
        (value) => !!value || "Required.",
        (value) => !isNaN(value) || "Enter a number",
      ],
    };
  },
  components: {},
  watch: {},
  methods: {
    getPath(path) {
      if (window.location.hostname === "localhost") {
        return `http://localhost:8081${path}`;
      }
      return `https://seekwell.io${path}`;
    },
    // getSession(Id) {
    //   let d = { validationId: "abcd", rowId: Id };
    //   console.log("inside get session");
    //   console.log("row id:", Id);
    //   //axios.get('/get_session_id?rowId=${rowId}')
    //   const path = store.getPath("/get_session_id");
    //   axios
    //     .post(path, d)
    //     .then((response) => {
    //       console.log("yoyoo", response);
    //       // Handle the response data
    //       // console.log("qqqqq",response.data.data.sessionId)
    //       // this.responseData = response.data.data.sessionId;
    //       // console.log(response.data.data.sessionId)
    //       // console.log("resdata:",this.responseData)

    //       return response.data.data.sessionId;
    //     })
    //     .catch((error) => {
    //       // Handle any errors
    //       console.error("Error fetching SessionId:", error);
    //     });
    // },
    checkLogin() {
      console.log("checkLogin...");
      if (!store.state.doLogin && window.location.hostname === "localhost") {
        console.log("checkLogin triggered...");
        store.state.loading = false;
        //var localJ = require('../../../../localVue.json');
        //store.state.sessionId = localJ.sessionId
        this.$parent.getUserData();
        this.$router.push({ path: "/" });
      }
    },
  },
};
</script>

<style>
.code {
  display: inline;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.hide {
  display: none;
}
</style>